module.exports = __webpack_public_path__ + "img/logo-glow.0ac643ba.png";